<!--
  * name: ScrollTopButton
  * description: 최상단 스크롤 버튼 컴포넌트
-->
<template>
  <button ref="btnTop" class="btn-top" :class="{ on: isOn }" type="button" @click="goTop()">
    TOP
  </button>
</template>

<script>
export default {
  name: 'ScrollTopButton',
  data() {
    return {
      isOn: false,
    };
  },
  created() {
    window.addEventListener('scroll', this.scrollFunc);
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollFunc);
  },
  methods: {
    goTop() {
      window.scrollTo(0, 0);
    },
    scrollFunc() {
      const currentY = window.pageYOffset || document.documentElement.scrollTop;
      const viewHeight = document.documentElement.clientHeight;
      const allHeight = document.body.clientHeight;
      const currentHeight = currentY + viewHeight;
      // console.log(currentY, viewHeight, allHeight);
      if (document.documentElement.scrollTop > 300) {
        this.$refs.btnTop.classList.add('on');
      } else {
        this.$refs.btnTop.classList.remove('on');
      }
      if(currentHeight > allHeight) {
        this.$refs.btnTop.classList.add('bottom');
      }else{
        this.$refs.btnTop.classList.remove('bottom');
      }
    },
  },
};
</script>
